import { isAuthenticationRequiredSyncError } from '@/lib/sync/error-utils';
import { syncGameDefinitions } from '@/lib/sync/game-definitions';
import type { UserId } from '@/schemas/ids';
import { enqueueSyncJob, registerSyncPlugin } from '../plugins.js';
import type { SyncPlugin } from '../plugins.js';

export const GAME_DEFINITIONS_SYNC_PLUGIN_KEY = 'game-definitions';

const gameDefinitionsPlugin: SyncPlugin<UserId> = {
  key: GAME_DEFINITIONS_SYNC_PLUGIN_KEY,
  createJobKey(userId: UserId) {
    return `game-definitions:${String(userId)}`;
  },
  createMetadata(userId: UserId) {
    return {
      entity: 'game-definitions',
      scope: String(userId),
      source: 'game-definitions-sync-plugin',
    };
  },
  async run(userId: UserId) {
    await syncGameDefinitions(userId);
  },
  shouldRetry(error) {
    return !isAuthenticationRequiredSyncError(error);
  },
};

const registerGameDefinitionsPlugin = registerSyncPlugin as (
  plugin: SyncPlugin<UserId>,
) => SyncPlugin<UserId>;
registerGameDefinitionsPlugin(gameDefinitionsPlugin);

export function enqueueGameDefinitionsSync(userId: UserId): void {
  const enqueue = enqueueSyncJob as (key: string, scope: UserId) => void;
  enqueue(GAME_DEFINITIONS_SYNC_PLUGIN_KEY, userId);
}
